export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  render(h) {
    const header = h('span', {}, this.item.header)
    return h('li', { class: 'navigation-header text-truncate' }, [header])
  },
}
